// ==================== USE PLANS HOOK ====================

import { useState, useEffect, useCallback } from 'react';
import { plansService } from '../services';
import type { SubscriptionPlan } from '../types';

interface UsePlansReturn {
  plans: SubscriptionPlan[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function usePlans(): UsePlansReturn {
  const [plans, setPlans] = useState<SubscriptionPlan[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlans = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      const data = await plansService.getPlans();
      setPlans(data);
    } catch (err) {
      const errorMessage = (err as { message?: string })?.message || 'Failed to load plans';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  return {
    plans,
    isLoading,
    error,
    refetch: fetchPlans,
  };
}

export default usePlans;

